import gql from 'graphql-tag'

export default gql`mutation ycmdAuthenticateChangePassword($password: String!, $current_password: String!) {
	ycmdAuthenticateChangePassword(password: $password, current_password: $current_password) {
		status
	}
}`
